import React, {useEffect, useRef, useState} from 'react';
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UButton from "ubs-framework/v2/UButton";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import {useSelector} from "react-redux";
import {errorFocus} from "ubs-framework/v2/common/function";
import UInput from "ubs-framework/v2/UInput";
import AsyncEmployeeSelect from "../../../../common/employee-access-select/async-employee-select";
import Select from "react-select";
import {getKeyName} from "ubs-framework/v2/common/function";

const RequestEvaluation = React.memo((props) => {
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));

    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _AEM = useSelector(e => e?.candidate?.addEvaluationModal || {});

    const [loader, setLoader] = useState(false);
    const [allValues, setAllValues] = useState({
        evaluationForm: null,
        requestFrom: []
    })

    const handle = {
        submit: e => {
            if (validator?.current?.allValid()) {
                props?.addEvaluation({ evaluationForm: allValues?.evaluationForm?.value || allValues?.evaluationForm,
                    requestFrom: allValues?.requestFrom?.map(e => e?.value)})
                props.close()
            } else {
                validator?.current?.showMessages();
                setLoader(false)
                errorFocus();
            }
        },
        change: (value, name) => {
            setAllValues({...allValues, [name]: value})
        },
        clear: (name) => {
            validator.current.hideMessageFor(name)
            validator.current.errorMessages[name] = undefined
            delete validator.current.errorMessages[name]
            validator.current.fields[name] = true
        }
    }

    useEffect(() => {
        const requestFrom = []
        props?.requestData?.requestFrom?.forEach(e => {
            requestFrom.push(_USERS[e])
        })
        setAllValues({...allValues, ...props?.requestData, requestFrom})
    }, []);

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={500}
                header={<h4>{_AEM?.data?._id ? 'Edit' : 'Add'} Evaluation</h4>}
                onClose={() => props.close()}
            >
                <div className="u_p-20">
                    <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label="Evaluation form" asterisk select selectValue={allValues?.evaluationForm}
                                    hasError={validator.current.message('evaluationForm', allValues?.evaluationForm, 'required')}>
                                <Select
                                    name="evaluationForm"
                                    className="u_input-select-inner"
                                    classNamePrefix="u_select"
                                    isClearable={true}
                                    placeholder={' '}
                                    value={getKeyName(props?.screeningQuestionsList, allValues?.evaluationForm)}
                                    onChange={e => handle.change(e, 'evaluationForm')}
                                    options={props?.screeningQuestionsList}
                                    noOptionsMessage={() => 'No Evaluation form found'}
                                    maxMenuHeight={150}
                                    menuPosition={'fixed'}
                                    onKeyDown={e => {
                                        if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                    }}
                                />
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput label="Request from" select asterisk selectValue={allValues?.requestFrom}
                                    hasError={validator.current.message('requestFrom', allValues?.requestFrom, 'required')}>
                                <AsyncEmployeeSelect
                                    value={allValues?.requestFrom}
                                    onChange={(e) => handle.change(e, 'requestFrom')}
                                    params={{isMulti: true, menuPlacement: 'auto'}}
                                    evaluation
                                />
                            </UInput>
                        </div>
                    </div>
                </div>

                <div className="u_modal-buttons">
                    <UButton disabled={loader} loading={loader} variant="white" type="Cancel" onClick={(e) => props.close()}/>
                    <UButton disabled={loader} loading={loader} isSubmit variant="blue" type="Save" cn="u_ml-10" onClick={handle.submit}/>
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default RequestEvaluation;
